<template lang="pug">
section.section.intro
  .intro__video
    video(preload="auto", muted="", autoplay="", loop="", data-keepplaying="", poster="~@/assets/images/intro/intro-bg.jpg")
      source(src="~@/assets/video/bg.webm", type="video/webm")
      source(src="~@/assets/video/bg.mp4", type="video/mp4")

  .intro__content
    img.intro__logo(:src="getImagePath")
    p(v-html="$t('intro.lead')")

    p
     | {{ $t("intro.calltoaction") }}
     a(@click="showPresent") {{ $t("intro.gift") }}

    .intro__content__action-button
      a.decor-button(v-if="isUserNotAuthed" @click="showPresent") {{ $t("intro.get_gift") }}
      DownloadButton(v-else)
        | {{ $t("intro.download") }}

</template>

<script>
import DownloadButton from "./DownloadButton.vue";
import UserMixin from "@chronos/frontend-base/src/mixins/user/UserMixin";
export default {
  name: "Intro",

  components: {
    DownloadButton,
  },

  mixins: [UserMixin],

  props: {
    isGiftClaimed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getImagePath() {
      return require("@/assets/images/intro/intro-logo.png");
    },
  },

  methods: {
    showPresent() {
      this.$emit("showPresent");
    },
  },
};
</script>
